// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-78211ef0] {\n  fill: #fff\n}\n.st62[data-v-78211ef0] {\n  fill: #2097e7\n}\n.st112[data-v-78211ef0] {\n  fill: #0068d6\n}\n", ""]);
// Exports
module.exports = exports;
